export const setColor = {
  primaryColor: "#AF646B",

  mainGrey: "#707070",
  blue: "#1F4A5E",
  pink: "#E3A6A1",
  mainWhite: "#E3DDD3",
};

export const setFont = {
  main: "'DM Mono', monospace;",
};

export const setFlex = (x, y) => {
  return `display:flex;align-items:${y};justify-content:${x}`;
};
